import { getRecentSearches, RecentSearchesResponse } from "common/apis";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Storage } from "common/storage";

export const useRecentSearches = () => {
  return useInfiniteQuery<RecentSearchesResponse, Error>({
    queryKey: ["recentSearches"],
    queryFn: async ({ pageParam }) => {
      const token = Storage.getCurrentUserToken() || "";
      const page = pageParam as number;
      return getRecentSearches(token, page, 5, "recent");
    },
    getNextPageParam: (lastPage) => {
      // Add safety check for pagination
      if (!lastPage?.pagination) {
        return undefined;
      }

      const { current_page, last_page } = lastPage.pagination;
      if (current_page < last_page) {
        return current_page + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    // Add these options for better error handling
    retry: 1,
    retryDelay: 1000,
  });
};